/**
 * Shared by the two pagination implementations in the design system: `@pg-design/pagination-module`
 * (`Pagination`) and the older `@pg-design/pagination` (`PaginationWithList`). Both render the same
 * ids, so a POM does not have to know which one an app happens to use.
 *
 * Only the module one is live: `PaginationWithList` has no importers left anywhere in the repo, and
 * every app that paginates reaches `Pagination` through `Table` (`design_system_modules/core/table`).
 * It keeps the same ids so the set stays one thing rather than two that drift, but the working hook
 * for PA - and for anything else today - is the module.
 *
 * `CONTAINER` sits on the `<nav>` wrapper. Visual specs need it to take the whole control out of
 * layout - it prints the total page count, so both its text and its width follow the dataset. The
 * link ids are no substitute: `NEXT_PAGE_LINK` is dropped when "next" is disabled, and reaching the
 * wrapper through it (`*:has(> [data-testid="next-page-link"])`) hangs off the component's internal
 * structure.
 *
 * `PAGE_SEPARATOR` renders through `Text`, which takes the id as `dataTestId` and forwards it - a
 * plain `data-testid` on that component is dropped without a type error, because TypeScript does not
 * check hyphenated JSX attributes against the prop type. Both implementations had it written that
 * way, so the id reached neither DOM until the unit tests here asserted on it.
 */
export const PAGINATION_TEST_IDS = {
    CONTAINER: "pagination-container",
    PREV_PAGE_LINK: "prev-page-link",
    NEXT_PAGE_LINK: "next-page-link",
    PAGE_SEPARATOR: "pagination-separator",
    GET_PAGE_LINK_TEST_ID: (page: number) => `page-${page}-link`,
    /**
     * Matches any page link, for "the last page whatever its number is" lookups, and captures the
     * number so the same constant reads it back off a matched link. One pattern rather than two:
     * `getByTestId` ignores capturing groups (verified against Chromium), so the capturing form
     * serves both uses and the id shape stays written down once.
     */
    PAGE_LINK_PATTERN: /^page-(\d+)-link$/
} as const;
/**
 * Shared by the two pagination implementations in the design system: `@pg-design/pagination-module`
 * (`Pagination`) and the older `@pg-design/pagination` (`PaginationWithList`). Both render the same
 * ids, so a POM does not have to know which one an app happens to use.
 *
 * Only the module one is live: `PaginationWithList` has no importers left anywhere in the repo, and
 * every app that paginates reaches `Pagination` through `Table` (`design_system_modules/core/table`).
 * It keeps the same ids so the set stays one thing rather than two that drift, but the working hook
 * for PA - and for anything else today - is the module.
 *
 * `CONTAINER` sits on the `<nav>` wrapper. Visual specs need it to take the whole control out of
 * layout - it prints the total page count, so both its text and its width follow the dataset. The
 * link ids are no substitute: `NEXT_PAGE_LINK` is dropped when "next" is disabled, and reaching the
 * wrapper through it (`*:has(> [data-testid="next-page-link"])`) hangs off the component's internal
 * structure.
 *
 * `PAGE_SEPARATOR` renders through `Text`, which takes the id as `dataTestId` and forwards it - a
 * plain `data-testid` on that component is dropped without a type error, because TypeScript does not
 * check hyphenated JSX attributes against the prop type. Both implementations had it written that
 * way, so the id reached neither DOM until the unit tests here asserted on it.
 */
export const PAGINATION_TEST_IDS = {
    CONTAINER: "pagination-container",
    PREV_PAGE_LINK: "prev-page-link",
    NEXT_PAGE_LINK: "next-page-link",
    PAGE_SEPARATOR: "pagination-separator",
    GET_PAGE_LINK_TEST_ID: (page: number) => `page-${page}-link`,
    /**
     * Matches any page link, for "the last page whatever its number is" lookups, and captures the
     * number so the same constant reads it back off a matched link. One pattern rather than two:
     * `getByTestId` ignores capturing groups (verified against Chromium), so the capturing form
     * serves both uses and the id shape stays written down once.
     */
    PAGE_LINK_PATTERN: /^page-(\d+)-link$/
} as const;
